'use client';

import { AnimatedRange } from './AnimatedBar';

export type KagemaneResolution = '480p' | '768p' | '720p' | '1080p' | '2k' | '4k';

export const KAGEMANE_RESOLUTIONS: readonly KagemaneResolution[] = ['480p', '720p', '1080p', '2k', '4k'];
export const KAGEMANE_HEYGEN_RESOLUTIONS: readonly KagemaneResolution[] = ['480p', '768p'];
export const KAGEMANE_RESOLUTIONS_25: readonly KagemaneResolution[] = ['480p', '720p', '1080p', '2k', '4k'];

export function KagemaneResolutionChoice({
  value,
  onChange,
  label,
  name,
  options = KAGEMANE_RESOLUTIONS,
  disabled = false,
  className = '',
}: {
  value: KagemaneResolution;
  onChange: (value: KagemaneResolution) => void;
  label: string;
  name: string;
  options?: readonly KagemaneResolution[];
  disabled?: boolean;
  className?: string;
}) {
  const index = Math.max(0, options.indexOf(value));
  return (
    <div className={className}>
      <AnimatedRange
        id={name}
        name={name}
        min={0}
        max={options.length - 1}
        step={1}
        value={index}
        ticks={options.length}
        label={label}
        valueLabel={options[index]}
        aria-label={label}
        aria-valuetext={options[index]}
        disabled={disabled}
        onChange={(event) => onChange(options[Number(event.target.value)])}
      />
    </div>
  );
}
